import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import BlockTypes from '../types/BlockTypes';
import { window } from './BrowserHelpers';
var requestIdleCallback = null;

function logs() {
  var _window$editorPerfAna = window.editorPerfAnalytics,
      constructor_time = _window$editorPerfAna.constructor_time,
      otherLogs = _objectWithoutProperties(_window$editorPerfAna, ["constructor_time"]);

  return otherLogs;
}

function setLogs(log) {
  window.editorPerfAnalytics = _objectSpread({}, window.editorPerfAnalytics || {}, {}, log);
}

function initLogs() {
  window.editorPerfAnalytics = {
    constructor_time: Date.now()
  };
}

function logValueStats(value) {
  var blocks = value.document.getBlocks();
  var block_count = blocks.size;
  var table_cell_count = blocks.filter(function (_ref) {
    var type = _ref.type;
    return type === BlockTypes.TABLE_CELL;
  }).size;
  var list_item_count = blocks.filter(function (_ref2) {
    var type = _ref2.type;
    return [BlockTypes.OL_LI, BlockTypes.UL_LI, BlockTypes.TODO].includes(type);
  }).size;
  setLogs({
    block_count: block_count,
    table_cell_count: table_cell_count,
    list_item_count: list_item_count
  });
}

function logMountTime() {
  setLogs({
    mount_time: Date.now() - window.editorPerfAnalytics.constructor_time
  });
}

function logIdleTime(onIdle) {
  window.cancelIdleCallback(requestIdleCallback);
  requestIdleCallback = window.requestIdleCallback(function () {
    setLogs({
      idle_time: Date.now() - window.editorPerfAnalytics.constructor_time
    });
    onIdle();
  });
}

function logServerTime() {
  setLogs({
    server_time: Date.now() - window.editorPerfAnalytics.constructor_time
  });
}

function clearLogs() {
  window.editorPerfAnalytics = {};
}

export default {
  initLogs: initLogs,
  logValueStats: logValueStats,
  logIdleTime: logIdleTime,
  logMountTime: logMountTime,
  logServerTime: logServerTime,
  clearLogs: clearLogs,
  logs: logs
};